import { ReactNode, ReactPortal, useEffect } from 'react';
import { createPortal } from 'react-dom';

import { usePopupsContext } from '../../contexts/PopupsContext';

interface PopupPortalProps {
    id: string;
    namespace?: string | null;
    children: ReactNode;
    requestClose?: () => void | null;
}

function PopupPortal({
    id,
    namespace = null,
    children,
    requestClose = null,
}: PopupPortalProps): ReactPortal | null {
    const { containers = null, register, unregister } = usePopupsContext();
    const container = containers[namespace || 'default'] || null;
    useEffect(() => {
        register(
            id,
            {
                requestClose,
            },
            namespace,
        );
        return () => {
            unregister(id, namespace);
        };
    }, [namespace, id, requestClose, register, unregister]);
    return container !== null ? createPortal(children, container) : null;
}

export default PopupPortal;
